module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmTitle2"
  }, [_c('a', {
    attrs: {
      "id": "h3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("PROLOGUE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("‘We can’t land there!’")]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_vm._v("‘I think the Queen would understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The fuel gauge had suddenly plummeted towards the empty mark – the only possible site was Windsor Great Park.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Before landing we made a dummy run to warn the strollers of our intention. Just before touchdown I shouted ‘Mind the cakes!’")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After rolling to a gentle stop, Eric visually checked the fuel tank, while I inspected the rear locker. The fuel was ample, there was no leak; the Tiger Moth gauge was up to its usual tricks, and the cakes were secure.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("We thankfully took off and flew on to our destination, Denham, where, to our great relief, we found the icing on our wedding cakes to be completely undamaged!")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An immediate phone call was made to the police in case the bemused onlookers had complained. Two days later we were married and flew away – to another unauthorized landing...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cb28344","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_prologue.vue
// module id = 75
// module chunks = 0